import {FormatDistanceToken, formatDistanceToNowStrict} from 'date-fns';
import {convertStringLocaleToDateFns} from 'platform/locale';
import {match} from 'ts-pattern';

import i18n from '@dms/i18n';

export const formatTimeDifferenceToNow = (
  timeDifference: number | Date,
  addSuffix: boolean = false
) =>
  formatDistanceToNowStrict(timeDifference, {
    addSuffix,
    locale: {
      formatDistance: (token: FormatDistanceToken, count: number) =>
        match<FormatDistanceToken, string>(token)
          .with('xHours', () => `${count} ${i18n.t('general.metric.h')}`)
          .with('xMinutes', () => `${count} ${i18n.t('general.metric.min')}`)
          .with('xSeconds', () => `${count} ${i18n.t('general.metric.s')}`)
          .otherwise(() =>
            convertStringLocaleToDateFns(i18n.language).formatDistance(token, count)
          ),
    },
  });
